import React from "react";
import { Button, CopyIcon, Toast } from "@sscs/ui";

type CopyPasswordProps = {
  password: string | undefined;
};

const CopyPassword = ({ password }: CopyPasswordProps): React.JSX.Element => {
  if (!password) return <>N/A</>;

  return (
    <Button
      onClick={async () => {
        await navigator.clipboard.writeText(password);
        Toast.show({
          title: "Password copied successfully!",
          type: "success",
        });
      }}
      tooltipTitle="Copy password"
      variant="text"
      size="small"
    >
      <CopyIcon />
      Copy
    </Button>
  );
};

export default CopyPassword;
